import { useMutation } from '@apollo/client';
import ExportIcon from '@clearkit/icons/glyphs/Export';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import ToastsContainer from '~/containers/Toasts';
import mutation from '~/pages/audiences/components/Layout/ActionsMenu/ExportAudience/mutation.graphql';

export default function ExportAudienceLinkedin({ audience, onExport }) {
  const [exportAudienceLinkedin] = useMutation(mutation, {
    onCompleted: () => {
      ToastsContainer.addSuccess(
        'Exporting LinkedIn audience',
        "You'll receive the export via email. This can take a few hours.",
      );
      onExport();
    },
    onError: () => {
      ToastsContainer.addError('There was an error exporting this audience.');
    },
    variables: {
      input: {
        id: audience.id,
        integration: 'linkedin',
      },
    },
  });

  return (
    <a
      className="flex items-center"
      onClick={() => {
        exportAudienceLinkedin();
      }}>
      <ListItemIcon>
        <ExportIcon />
      </ListItemIcon>{' '}
      Export Linkedin
    </a>
  );
}

ExportAudienceLinkedin.propTypes = {
  audience: PropTypes.object.isRequired,
  onExport: PropTypes.func.isRequired,
};
